import React, { useState } from 'react';
import { cadastroService } from '../../services/api';
import DraggableWindow from './DraggableWindow';

// Campos editáveis enviados ao salvar (devem bater com a allowlist do proxy).
// SITUAÇÃO/DEMISSÃO NÃO entram aqui: mudar situação no legado bloqueia o login
// (acesso.STATUS, criptografado), o que esta tela não faz. Desligamento deve
// ser feito pelo cadastro oficial (SCE115).
const CAMPOS = [
  'NOME', 'NRFUNC', 'RG', 'CPF', 'PIS', 'DTNASCIMENTO', 'ADMISSAO',
  'CDFIL', 'SETOR', 'NIVEL', 'ENDERECO', 'TELEFONE', 'CELULAR', 'EMAIL',
  'LIMITE', 'HORAENT', 'HORASAI', 'HORAINTINI', 'HORAINTFIM', 'OBS',
];

const WindowCadFuncionario = ({ onClose, onMinimize, isMinimized, zIndex, onFocus }) => {
  const [termo, setTermo] = useState('');
  const [resultados, setResultados] = useState([]);
  const [form, setForm] = useState(null);
  const [buscando, setBuscando] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const buscar = async () => {
    setErro(''); setSucesso(''); setResultados([]); setForm(null);
    if (!termo.trim()) { setErro('Informe a matrícula/código ou o nome.'); return; }
    setBuscando(true);
    try {
      const rows = await cadastroService.buscarFuncionario(termo);
      if (!rows || rows.length === 0) setErro('Nenhum funcionário encontrado.');
      else if (rows.length === 1) carregar(rows[0]);
      else setResultados(rows);
    } catch (e) {
      setErro(e.message || 'Erro ao buscar.');
    } finally {
      setBuscando(false);
    }
  };

  const carregar = (f) => { setResultados([]); setForm({ ...f }); };

  const salvar = async () => {
    if (!form?.CDFUN) return;
    setErro(''); setSucesso('');
    const campos = {};
    CAMPOS.forEach((k) => { campos[k] = form[k] ?? ''; });
    setSalvando(true);
    try {
      await cadastroService.salvarFuncionario(form.CDFUN, campos, form.CDEMP || 1);
      setSucesso(`Funcionário ${form.CDFUN} alterado com sucesso.`);
    } catch (e) {
      setErro(e.message || 'Erro ao salvar.');
    } finally {
      setSalvando(false);
    }
  };

  const lbl = { display: 'block', fontSize: 11, fontWeight: 600, color: '#475569', marginBottom: 3 };
  const inp = { width: '100%', padding: '7px 9px', border: '1px solid #cbd5e1', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' };
  const F = ({ k, label, w = 1, type = 'text', readOnly = false }) => (
    <div style={{ flex: w, minWidth: 110 }}>
      <label style={lbl}>{label}</label>
      <input style={{ ...inp, background: readOnly ? '#f1f5f9' : '#fff' }} type={type}
        value={form?.[k] ?? ''} readOnly={readOnly}
        onChange={(e) => set(k, e.target.value)} />
    </div>
  );

  return (
    <DraggableWindow title="Alteração de Cadastro — Funcionário" icon="fa-id-badge"
      onClose={onClose} onMinimize={onMinimize} isMinimized={isMinimized}
      zIndex={zIndex} onFocus={onFocus} initialWidth={760}>
      <div style={{ padding: 16 }}>
        {/* Busca */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
          <input style={{ ...inp, flex: 1 }} value={termo} placeholder="Matrícula/código ou nome do funcionário..."
            onChange={(e) => setTermo(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') buscar(); }} autoFocus />
          <button onClick={buscar} disabled={buscando}
            style={{ padding: '8px 16px', border: 'none', borderRadius: 6, background: '#0078d7', color: '#fff', cursor: 'pointer' }}>
            {buscando ? '...' : 'Buscar'}
          </button>
        </div>

        {resultados.length > 0 && (
          <div style={{ border: '1px solid #e2e8f0', borderRadius: 8, marginBottom: 14, maxHeight: 200, overflowY: 'auto' }}>
            {resultados.map((f) => (
              <div key={f.CDFUN} onClick={() => carregar(f)}
                style={{ padding: '8px 10px', borderBottom: '1px solid #f1f5f9', cursor: 'pointer', fontSize: 13 }}>
                <b>{f.CDFUN}</b> — {f.NOME} {f.NRFUNC ? `· matr. ${f.NRFUNC}` : ''}
              </div>
            ))}
          </div>
        )}

        {form && (
          <>
            <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
              <F k="CDFUN" label="Código" w={0.5} readOnly />
              <F k="NOME" label="Nome" w={2} />
              <F k="NRFUNC" label="Matrícula" w={0.7} />
            </div>
            <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
              <F k="CPF" label="CPF" />
              <F k="RG" label="RG" />
              <F k="PIS" label="PIS" />
              <F k="DTNASCIMENTO" label="Nascimento" type="date" />
            </div>
            <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
              <F k="CDFIL" label="Filial" w={0.6} />
              <F k="SETOR" label="Setor" />
              <F k="NIVEL" label="Nível" w={0.6} />
              <F k="ADMISSAO" label="Admissão" type="date" />
            </div>
            {form.FGSITUAC !== undefined && (
              <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 10 }}>
                Situação atual: <b>{({ '1': 'Ativo', '2': 'Compras Suspensa', '3': 'Desligado' })[String(form.FGSITUAC)] || form.FGSITUAC}</b>.
                Para alterar situação/desligamento (que bloqueia o login), use o cadastro oficial.
              </div>
            )}
            <F k="ENDERECO" label="Endereço" />
            <div style={{ display: 'flex', gap: 10, margin: '10px 0' }}>
              <F k="TELEFONE" label="Telefone" />
              <F k="CELULAR" label="Celular" />
              <F k="EMAIL" label="E-mail" w={2} />
            </div>
            <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
              <F k="HORAENT" label="Hora Entr." />
              <F k="HORASAI" label="Hora Saída" />
              <F k="HORAINTINI" label="Interv. Ini" />
              <F k="HORAINTFIM" label="Interv. Fim" />
              <F k="LIMITE" label="Limite Compra" />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={lbl}>Observação</label>
              <textarea style={{ ...inp, minHeight: 56, resize: 'vertical' }}
                value={form.OBS ?? ''} onChange={(e) => set('OBS', e.target.value)} />
            </div>

            <button onClick={salvar} disabled={salvando}
              style={{ width: '100%', padding: 12, border: 'none', borderRadius: 8, background: salvando ? '#94a3b8' : '#16a34a', color: '#fff', fontWeight: 700, fontSize: 15, cursor: salvando ? 'not-allowed' : 'pointer' }}>
              {salvando ? 'Salvando...' : 'Salvar Alterações'}
            </button>
          </>
        )}

        {erro && <div style={{ background: '#fee2e2', color: '#b91c1c', padding: '8px 12px', borderRadius: 6, marginTop: 12, fontSize: 13 }}><i className="fas fa-triangle-exclamation" /> {erro}</div>}
        {sucesso && <div style={{ background: '#dcfce7', color: '#166534', padding: '8px 12px', borderRadius: 6, marginTop: 12, fontSize: 13 }}><i className="fas fa-check-circle" /> {sucesso}</div>}
      </div>
    </DraggableWindow>
  );
};

export default WindowCadFuncionario;
